import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { ListingCard, PaginationLinks, FieldSelect } from '../../components';
import css from './SearchResultsPanel.module.css';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import FieldTextInput from '../../components/FieldTextInput/FieldTextInput';
import CustomTrackSelectFieldMaybe from '../../forms/EditListingDescriptionForm/CustomTrackSelectFieldMaybe';
import { findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';
import { Form, Field } from 'react-final-form';
import UniversitySearch from '../../forms/EditListingProfessionalInfoForm/UniversitySearch';

const sharetribeSdk = require('sharetribe-flex-sdk');
// import { indexOf } from 'core-js/core/array';
import { types as sdkTypes } from '../../util/sdkLoader';

const topRankedSchools = [

  "Yale Law School",
  
       "Harvard Law School"
  ,
  
       "Stanford Law School"
  ,
  
       "Columbia Law School"
  ,
  
       "University of Chicago Law School"
  ,
  
       "New York University School of Law"
  ,
  
       "University of Pennsylvania Law School"
  ,
  
       "University of Virginia School of Law"
  ,
  
       "UC Berkeley School of Law - University of California at Berkeley"
  ,
  
       "Duke University School of Law"
  ,
  
       "University of Michigan Law School"
  ,
  
       "Northwestern University Pritzker School of Law"
  ,
  
       "Cornell Law School"
  ,
  
       "Georgetown University Law Center"
  ,
  
       "University of Texas School of Law"
  ,
  
       "UCLA School of Law - University of California at Los Angeles"
  ,
  
       "Vanderbilt University Law School"
  ,
  
       "Washington University School of Law"
  ,
  
       "Emory University School of Law"
  ,
  
       "The George Washington University Law School"
  ,
  
       "University of Minnesota Law School"
  ,
  
       "USC Gould School of Law - University of Southern California"
  ,
  
       "University of Alabama School of Law"
  ,
  
       "William & Mary Law School"
  ,
  
       "University of Washington School of Law"
  ,
  
       "Notre Dame Law School"
  ,
  
       "Boston University School of Law"
  ,
  
       "University of Iowa College of Law"
  ,
  
       "Indiana University Maurer School of Law"
  ,
  
       "University of Georgia School of Law"
  ,
  
       "Arizona State University - Sandra Day O'Connor College of Law"
  ,
  
       "Michael E. Moritz College of Law at Ohio State University"
  ,
  
       "University of North Carolina School of Law"
  ,
  
       "University of Wisconsin Law School"
  ,
  
       "Wake Forest University School of Law"
  ,
  
       "Boston College Law School"
  ,
  
       "J. Reuben Clark Law School at Brigham Young University"
  ,
  
       "Fordham University School of Law"
  ,
  
       "UC Davis School of Law - University of California at Davis"
  ,
  
       "University of Arizona James E. Rogers College of Law"
  ,
  
       "University of Illinois College of Law"
  ,
  
       " SMU Dedman School of Law - Southern Methodist University"
  ,
  
       "University of Colorado School of Law"
  ,
  
       "Washington and Lee University School of Law"
  ,
  
       "Florida State University College of Law"
  ,
  
       "George Mason University School of Law"
  ,
  
       "Tulane University School of Law"
  ,
  
       "University of Maryland School of Law"
  ,
  
       "University of Florida Levin College of Law"
  ,
  
       "University of Utah - S.J. Quinney College of Law",
  

       "UC Davis School of Veterinary Medicine",

  
       "Cornell University College of Veterinary Medicine"
  ,
  
       "Colorado State University College of Veterinary Medicine"
  ,
  
       "Ohio State University College of Veterinary Medicine"
  ,
  
       "Ontario Veterinary College at University of Guelph"
  ,
  
       "University of Pennsylvania School of Veterinary Medicine"
  ,
  
       "North Carolina State University College of Veterinary Medicine"
  ,
  
       "Texas A&M College of Veterinary Medicine & Biomedical Sciences"
  ,
  
       "Faculty of Veterinary Medicine at Université de Montréal"
  ,
  
       "University of Wisconsin School of Veterinary Medicine "
  ,
  
       "University of Florida College of Veterinary Medicine"
  ,
  
       "Faculty of Veterinary Medicine at University of Calgary \n"
  ,
  
       "University of Georgia College of Veterinary Medicine"
  ,
  
       "Cummings School of Veterinary Medicine at Tufts University"
  ,
  
       "University of Minnesota College of Veterinary Medicine"
  
,
       "Harvard University School of Dental Medicine",

  
       "University of Michigan School of Dentistry"
  ,
  
       "University of Pennsylvania School of Dental Medicine"
  ,
  
       "UCLA School of Dentistry"
  ,
  
       "UCSF School of Dentistry"
  ,
  
       "University of North Carolina Chapel Hill School of Dentistry"
  ,
  
       "University of Washington School of Dentistry"
  ,
  
       "University at Buffalo School of Dental Medicine"
  ,
  
       "New York University College of Dentistry"
  ,
  
       "Herman Ostrow School of Dentistry of USC"
  ,
  
       "University of Pittsburgh School of Dental Medicine"
  ,
  
       "University of Iowa College of Dentistry and Dental Clinics"
  ,
  
       "https://www.dentistrytoday.com/news/todays-dental-news/item/6667-the-united-states-again-dominates-the-world-s-best-dental-schools-in-2020"
  
 ,
       "Harvard Medical School",

  
       "New York University School of Medicine"
  ,
  
       "Duke University School of Medicine"
  ,
  
       "Columbia University Roy and Diana Vagelos College of Physicians and Surgeons"
  ,
  
       "Stanford University School of Medicine"
  ,
  
       "UCSF School of Medicine"
  ,
  
       "Johns Hopkins University School of Medicine"
  ,
  
       "Washington University School of Medicine"
  ,
  
       "Perelman School of Medicine at the University of Pennsylvania"
  ,
  
       "Yale School of Medicine"
  ,
  
       "Mayo Clinic Alix School of Medicine"
  ,
  
       "Saint Louis University School of Medicine"
  ,
  
       "University of Pittsburgh School of Medicine"
  ,
  
       "Vanderbilt University School of Medicine"
  ,
  
       "Northwestern University Feinberg School of Medicine"
  ,
  
       "University of Michigan Medical School"
  ,
  
       "Icahn School of Medicine at Mount Sinai"
  ,
  
       "University of Chicago Pritzker School of Medicine"
  ,
  
       "Weill Cornell Medical College"
  ,
  
       "David Geffen School of Medicine at UCLA"
  ,
  
       "University of California - San Diego School of Medicine"
  ,
  
       "Baylor College of Medicine"
  ,
  
       "Emory University School of Medicine"
  ,
  
       "University of North Carolina School of Medicine"
  ,
  
       "Case Western Reserve University School of Medicine"
  ,
  
       "University of Texas Southwestern Medical School at Dallas"
  ,
  
       "University of Colorado School of Medicine"
  ,
  
       "University of Maryland School of Medicine"
  ,
  
       "Oregon Health & Science University School of Medicine"
  ,
  
       "University of Alabama at Birmingham School of Medicine"
  ,
  
       "https://www.usnews.com/best-graduate-schools/top-medical-schools/research-rankings"
  

 ,
       "Duke University Medical Center - Physician Associate Program",

  
       "University of Iowa - Physician Associate Program"
  ,
  
       "Baylor College of Medicine - Physician Associate Program"
  ,
  
       "University of Utah School of Medicine - Physician Associate Program"
  ,
  
       "Emory University - Physician Associate Program"
  ,
  
       "George Washington University - Physician Associate Program"
  ,
  
       "University of Colorado - Physician Associate Program"
  ,
  
       "Stanford University - Physician Associate Program"
  ,
  
       "Wake Forest University - Physician Associate Program"
  ,
  
       "Drexel University - Physician Associate Program"
  ,
  
       "Oregon Health and Science University - Physician Associate Program"
  ,
  
       "University of Washington School of Medicine - Physician Associate Program"
  ,
  
       "Quinnipiac University - Physician Associate Program"
  ,
  
       "Rosalind Franklin University of Medicine - Physician Associate Program"
  ,
  
       "University of Nebraska - Physician Associate Program"
  ,
  
       "University of Wisconsin - Madison - Physician Associate Program"
  ,
  
       "University of Wisconsin - La Crosse - Physician Associate Program"
  ,
  
       "Midwestern University - Physician Associate Program"
  ,
  
       "Rutgers University - Physician Associate Program"
  ,
  
       "Stanford University - Physician Associate Program"
  ,
    

 ,
       "Stanford University",
  
       "Harvard University"
  ,
  
       "University of California - Berkeley"
  ,
  
       "University of Toronto"
  ,
  
       "Cornell University"
  ,
  
       "University of British Columbia"
  ,
  
       "University of Michigan - Ann Arbor"
  ,
  
       "University of Washington"
  ,
  
       "University of Texas at Austin"
  ,
  
       "University of Pennsylvania"
  ,
  
       "University of Illinois at Urbana-Champaign"
  ,
  
       "University of Wisconsin - Madison"
  ,
  
       "University of California - Los Angeles"
  ,
  
       "Columbia University in the City of New York"
  ,
  
       "Yale University"
  ,
  
       "University of Minnesota - Twin Cities"
  ,
  
       "McGill University"
  ,
  
       "University of Alberta"
  ,
  
       "Simon Fraser University"
  ,
  
       "Pennsylvania State University - Penn State Main Campus"
  ,
  
       "Carnegie Mellon University"
  ,
  
       "University of Virginia"
  ,
  
       "University of Waterloo"
  ,
  
       "Purdue University"
  ,
  
       "University of Arizona"
  ,
  
       "University of Calgary"
  ,
  
       "University of California - San Diego"
  ,
  
       "Princeton University"
  ,
  
       "New York University"
  ,
  
       "Ohio State University"
  ,
  
       "Michigan State University"
  ,
  
       "University of Chicago"
  ,
  
       "University of Southern California"
  ,
  
       "University of Florida"
  ,
  
       "University of Maryland - College Park"
  ,
  
       "University of California - Davis"
  ,
  
       "University of North Carolina at Chapel Hill"
  ,
  
       "Duke University"
  ,
  
       "York University"
  ,
  
       "Rutgers - The State University of New Jersey"
  ,
  
       "University of Victoria"
  ,
  
       "Arizona State University"
  ,
  
       "Texas A & M University"
  ,
  
       "California Institute of Technology"
  ,
  
       "Université de Montréal"
  ,
  
       "Virginia Polytechnic Institute and State University"
  ,
  
       "University of California - Irvine"
  ,
  
       "University of Colorado at Boulder"
  ,
  
       "Queen's University"
  ,
  
       "McMaster University"
  ,
  
       "University of Pittsburgh"
  ,
  
       "University of Utah"
  ,
  
       "University of California - Santa Barbara"
  ,
  
       "Université Laval"
  ,
  
       "North Carolina State University"
  ,
  
       "Boston University"
  ,
  
       "Washington University in St Louis"
  ,
  
       "The University of Western Ontario"
  ,
  
       "Johns Hopkins University"
  ,
  
       "University of Georgia"
  ,
  
       "Northwestern University"
  ,
  
       "University of Iowa"
  ,
  
       "Georgia Institute of Technology"
  ,
  
       "Washington State University"
  ,
  
       "University of Nebraska - Lincoln"
  ,
  
       "University of Oregon"
  ,
  
       "Colorado State University"
  ,
  
       "University of Manitoba"
  ,
  
       "University of Saskatchewan"
  ,
  
       "University of Ottawa"
  ,
  
       "University of Guelph"
  ,
  
       "Florida State University"
  ,
  
       "Tufts University"
  ,
  
       "Iowa State University"
  ,
  
       "Rice University"
  ,
  
       "University of Massachusetts-Amherst"
  ,
  
       "University of Kentucky"
  ,
  
       "Lexington Community College"
  ,
  
       "Massachusetts Institute of Technology"
  ,
  
       "SUNY at Buffalo"
  ,
  
       "Université du Québec à Montréal"
  ,
  
       "San Diego State University"
  ,
  
       "Carleton University"
  ,
  
       "Dalhousie University"
  ,
  
       "Brigham Young University"
  ,
  
       "George Mason University"
  ,
  
       "Vanderbilt University"
  ,
  
       "Dartmouth College"
  ,
  
       "Georgetown University"
  ,
  
       "University of Missouri - Columbia"
  ,
  
       "Memorial University of Newfoundland"
  ,
  
       "Brown University"
  ,
  
       "Emory University"
  ,
  
       "University of South Florida"
  ,
  
       "Concordia University"
  ,
  
       "University of California - San Francisco"
  ,
  
       "University of California - Santa Cruz"
  ,
  
       "Oregon State University"
  ,
  
       "George Washington University"
  ,
  
       "University of Houston"
  

]

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

  const { UUID } = sdkTypes;
  
const SearchResultsPanel = props => {
  const { className, rootClassName, listings, pagination, search, setActiveListing } = props;
  const classes = classNames(rootClassName || css.root, className);
  const [isOpen, setOpen] = useState(false);
  const [track, setTrack] = useState("dental");
  const [contactSchool, setContactSchool] = useState("");
  const [isHelper, setIsHelper] = useState(true);
  const [user, setUser] = useState('');


     useEffect(() => {

     sdk.currentUser.show().then(res => {
        if(res.data.data.attributes.profile.publicData){
        setIsHelper(res.data.data.attributes.profile.publicData.helper)
        setUser(res.data.data.attributes)

          }
      }).catch(error => {
        console.log(error.stack)});

    }, []);
    
  const windowObj = typeof window !== "undefined" ? window : "";

  const handleOpen = () => {
    setOpen(true);
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleTrack = (e) => {
    setTrack(e.target.value)
  }


  const onSubmit = async values => {

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
                          to: 'info@theappbuddy.com', // Change to your recipient
                          from: 'info@theappbuddy.com', // Change to your verified sender
                          subject: "Student can't find what he's looking for",
                          text: `${values.name} ( email: ${values.email}) is following the ${track} track and he want's to go to ${contactSchool}, his preferences are: ${values.preferences}`
                        })
                   }
    
      fetch('/api/sendgrid-email', requestOptions)
        .then(resp => resp.text())
        .then(resp => {
          handleClose();
        }).catch(error => {
          console.log(error.stack)
        });
  
  }


  const trackOptions = findOptionsForSelectFilter('track', config.custom.filters);

  const onManageDisableScrolling = (componentId, scrollingDisabled = true) => {
    // We are just checking the value for now
    console.log('Toggling Modal - scrollingDisabled currently:', componentId, scrollingDisabled);
  };

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  // Panel width relative to the viewport
  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');


 


  let filteredListings = listings.filter(listing => {
    return listing.attributes.publicData.listingType === "masterListing";
  });

  //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
  let listingsForStudent

  if(!isHelper){

    const filteredListings = listings.filter(listing => {
      return listing.attributes.publicData.listingType === "masterListing";
    });

    const filteredListingsCopy = [...filteredListings];
    const filteredListingsForStudent = [];


      const qustion1 = user.profile ? user.profile.publicData.question1 : 0;   //accepted to my dream school
      const qustion2 = user.profile ?  user.profile.publicData.question2 : 0;  //has gap year
      const qustion3 = user.profile ?  user.profile.publicData.question3 : 0;  //to be at a top ranked school
      const qustion4 = user.profile ?  user.profile.publicData.question4 : 0;  // to be a reapplicant


      //helper functions ---------------------

      const sortArray = (array) => {
        var temp = 0;
        for (var i = 0; i < array.length; i++) {
          for (var j = i; j < array.length; j++) {
            if (array[j]["importance"] < array[i]["importance"]) {
              temp = array[j];
              array[j] = array[i];
              array[i] = temp;
            }
          }
        }
        return array;
      }

      const findCommonElement = (array1, array2) => {
          
        let answersArray = [];
        // Loop for array1
       array1.forEach(item => {
            if(array2.some(element => {
                return (element.State == item.State && element.School == item.School)
            })){
              answersArray.push("found")
            }else{
              console.log("not found")
            }
       })

        if(answersArray.length !== 0){
          return true
        }else{
          return false
        }
          
        // Return if no common element exist
     
    }

    //-------------------------------------
      const questionsArray = [
        {
          question: 1,
          importance: qustion1,
          searchParam: "acceptedAtSchools",
          userChoise1: user.profile ? user.profile.publicData.dreamSchools : []
        },{
          question: 3,
          importance: qustion3,
          searchParam: "schoolForSearch",
          userChoise2: topRankedSchools
        }
    ]

    const questionsArrayInImportanceOrder = sortArray(questionsArray).reverse();

      questionsArrayInImportanceOrder.forEach(question => {
        const questionSearchParam = question.searchParam;

        if(question.userChoise1){


          const luckyListings = filteredListingsCopy.filter(listing => {

                const listingsAcceptedAtSchoolArray = listing.attributes.publicData.acceptedAtSchools ? listing.attributes.publicData.acceptedAtSchools : [];

                const foundListing = findCommonElement(listingsAcceptedAtSchoolArray, question.userChoise1);
                
                return foundListing;
          })

          luckyListings.forEach(item => {
            const index = filteredListingsCopy.indexOf(item);
            filteredListingsCopy.splice(index,1)
          })

          luckyListings.forEach(item => {
            filteredListingsForStudent.push(item)
          })    

        }else if(question.userChoise2){


          const luckyListings = filteredListingsCopy.filter(listing => {

                const listingsSchoolsArray = listing.attributes.publicData.schoolForSearch ? listing.attributes.publicData.schoolForSearch : [];

                const foundListing = findCommonElement(listingsSchoolsArray, question.userChoise2);
                
                return foundListing;
          })

          luckyListings.forEach(item => {
            const index = filteredListingsCopy.indexOf(item);
            filteredListingsCopy.splice(index,1)
          })

          luckyListings.forEach(item => {
            filteredListingsForStudent.push(item)
          })    

        }
        
    })

    listingsForStudent = filteredListingsForStudent

  }

  //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&


  const listingsForSearch = isHelper ? filteredListings : listingsForStudent;
  const noResults = listingsForSearch.length === 0;

  const noResultsPage = typeof window === "undefined" ? false : windowObj.location.href.search("pub_track") === -1;

  if(noResults && !noResultsPage){
     
     const dreamSchools = user.profile ? user.profile.publicData.dreamSchools : [];
     if(dreamSchools.length !== 0){
          const onlySchoolsNamesArray = dreamSchools.map(json => {
               const encodedSchool = encodeURI(json.School);
     
               const splittedEncodedSchool =  encodedSchool.split("").map(item => {
                    return item === "&" ? "%26" : item
               });
               
          
               const finalEncodedSchool = splittedEncodedSchool.join("");
               return finalEncodedSchool
               })
     
               windowObj.history.pushState('', '', `/s?pub_combinedSchoolSearch=has_any%3A${onlySchoolsNamesArray.join("%2C")}`)
               windowObj.location.reload()
     }
    
  }

 

  return (
    <div className={classes}>
         {noResultsPage && !noResults ? (
              <div className={css.noResultsMessage}>
               <p>We couldn't find an exact match for you,hope one of these helpers can help</p>
              </div>
         ) : null}

         <div className={ props.totalItems === 0 ? css.listingCardsNoResults : css.listingCards}>
               {listingsForSearch.map(l => (
                 <div className={css.listingsOnSearchWrapper}>
                 <ListingCard
                   className={css.listingCard}
                   key={l.id.uuid}
                   listing={l}
                   renderSizes={cardRenderSizes}
                   setActiveListing={setActiveListing}
                 />
           
                 </div>
               ))}
       
       
               <div className={ props.totalItems === 0 ? css.contactUsNoResults : css.contactUs}>
                   <h3>Can’t find who you’re looking for?</h3>
                   <p>If you fill out this form, we’ll look for a student that fits your requirements, and email you when we think we have a good match.</p>
                   <Modal
                       {...props}
                       isOpen={isOpen}
                       onClose={() => {
                         setOpen(false);
                         console.log('Closing modal');
                       }}
                       onManageDisableScrolling={onManageDisableScrolling}
                     >
       
                   
                       <Form
                         onSubmit={onSubmit}
                         render={({
                           submitError,
                           handleSubmit,
                           form,
                           submitting,
                           pristine,
                           values
                         }) => {
                           return(
                       <form onSubmit={handleSubmit}>
                         <div>
                             <div>
                             <h3>Can’t find who you’re looking for?</h3>
                             <p>If you fill out this form, we’ll look for a student that fits your requirements, and email you when we think we have a good match.</p>
                             </div>
       
       
                         <div className={css.formRow}>
                               <label>Name:</label>
                               <Field
                                 className={css.field}
                                 type="text"
                                 component="input"
                                 name="name"
                               />
                       </div>
       
                       <div className={css.formRow}>
                       <label>Email:</label>
                       <Field
                         className={css.field}
                         type="email"
                         component="input"
                         name="email"
                       />
                       </div>
       
                        <div className={css.leftWriting}>  
       
                       {/* <FieldSelect className={css.service} name={"track"} id={"track"} label={"What track are you on?"}> */}
                           
                             <select name="track" onChange={handleTrack}>
                             <option key={"dental"} value={"dental"}>
                               {'Dental'}
                             </option>
                             <option key={"law"} value={"law"} >
                               {'Law'}
                             </option>
                             <option key={"medical"} value={"medical"} >
                               {'Medical'}
                             </option>
                             </select>
                             
                          
                         {/* </FieldSelect> */}
                       </div> 
       
       
                       <div className={css.leftWriting}>
                          <label>Dream school ?</label>   
                         <UniversitySearch
                           id="fomrSchool"
                           name="formSchool"
                           track={track}
                           contactUs={true}
                           setContactSchool={setContactSchool}
                           />
                       </div>
       
       
                       <div className={css.formRow}>
                       <label>Any other preferences</label>
                       <Field
                         className={css.field}
                         type="textarea"
                         component="input"
                         name="preferences"
                       />
                       </div>
       
                       <Button type="submit" disabled={submitting || pristine} className={css.contactUsButton}>SUBMIT</Button>
       
       
                       </div>
                          </form>
                           )
                         }
                           
                         }
                       >
                       
       
                       </Form>
                  
       
                 </Modal>
                   <Button className={css.contactUsButton} onClick={handleOpen}>CONTACT US</Button>
               </div>
       
               {props.children}
             </div>
             
     {paginationLinks}
    </div>
    
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
};

const { array, node, object, string } = PropTypes;

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
};

export default SearchResultsPanel;

